import { useCloverPaymentForm } from '@getbento/payments/providers/CloverPaymentFormProvider';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { ModalType, useModal } from 'reservations/base/providers/ModalProvider';
import { BaseChecklessPaymentsButton } from 'reservations/checklessPayments/components/BaseChecklessPaymentsButton';

export const RetrieveTokenButtonV2 = () => {
  const { handleHasLoaded, handleIsLoading } = useLoadingSpinner();
  const { open } = useModal();

  const handlePaymentForm = useCloverPaymentForm()?.handlePaymentForm;

  const onSubmit = async () => {
    handleIsLoading('');
    await handlePaymentForm?.();
    open(ModalType.ChecklessAddTip);
    handleHasLoaded();
  };

  return (
    <BaseChecklessPaymentsButton
      dataTestId="retrieve-token-button-v2"
      buttonText="NEXT"
      handleClick={onSubmit}
    />
  );
};
